// **********************************************************
// Customer Stories
// **********************************************************

const customerStoriesSlider = document.querySelectorAll('[data-slider="customer-stories-slider"]');

const customerStoriesSliderOptions = {
  slidesPerView: 3,
  slidesPerGroup: 3,
  spaceBetween: 20,
  speed: 800,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  loop: true,
  breakpoints: {
    767: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 20,
    },
    1023: {
      slidesPerView: 6,
      slidesPerGroup: 6,
      spaceBetween: 20,
    },
    1199: {
      slidesPerView: 7,
      slidesPerGroup: 7,
      spaceBetween: 48,
    },
  },
};

customerStoriesSlider.forEach((el) => {
  const customerStoriesParent = el.closest('.customer-stories');
  const paginationElement = customerStoriesParent.querySelector('.swiper-pagination');
  customerStoriesSliderOptions.pagination.el = paginationElement;

  new Swiper(el, customerStoriesSliderOptions);
});
